/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all } from "redux-saga/effects";
import * as notificationAction from "./actions";
import { FetchPendingUserNotif, FetchTrialPeriodNotif } from "./services";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchPendingUserNotifSaga(action) {
  try {
    const response = yield call(FetchPendingUserNotif, action.payload);
    const pendingNotification =
      response && response.data && response.data.success ? response.data : null;
    yield put(
      notificationAction.FetchPendingUserNotifSuccess(pendingNotification),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(notificationAction.FetchPendingUserNotifFailed(error));
  }
}
//
// ─── TRAIAL PERIOD NOTIFICATION ───────────────────────────────────────────────────────
//

export function* fetchTrialPeriodNotifSaga(action) {
  try {
    const response = yield call(FetchTrialPeriodNotif, action.payload);
    const pendingNotification =
      response &&
      response.data &&
      response.data.data &&
      response.data.data.trialDataUsagePercent > 0
        ? response.data
        : {};
    yield put(
      notificationAction.FetchTrialPeriodNotifSuccess(pendingNotification),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(notificationAction.FetchTrialPeriodNotifFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* notificationWatcher() {
  yield all([
    takeLatest(
      notificationAction.types.FETCH_PENDING_USER_NOTIF,
      fetchPendingUserNotifSaga,
    ),
    takeLatest(
      notificationAction.types.FETCH_TRIAL_PERIOD_NOTIF,
      fetchTrialPeriodNotifSaga,
    ),
  ]);
}
